<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">远程更新/新增</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <span
        >针对合作伙伴的特殊子版本功能需求，每个主版本的子版本号段50及以上都为“特殊子版本”的版本号，执行该主版本的全域插件更新时将绕开该号段的设备，如需要恢复到正常子版本，需要重新安装主版本；
      </span>
    </div>
    <div style="padding: 20px">
      <div class="item_title">基本设置</div>
      <Form
        ref="form"
        :model="data"
        :rules="rule"
        :label-width="100"
        style="margin-left: 15px"
      >
        <Row>
          <Col span="9">
            <FormItem prop="name" label="软件名称">
              <Select
                v-model="data.name"
                placeholder="请选择"
                style="width: 300px"
                @on-change="onSelectName"
              >
                <Option value="服务窗口版">服务窗口版</Option>
                <Option value="通用基础版">通用基础版</Option>
              </Select>
            </FormItem>
            <FormItem prop="version" label="软件主版本">
              <Select
                v-model="data.version"
                placeholder="请选择"
                filterable
                allow-create
                @on-create="versionCreate"
                style="width: 300px"
              >
                <Option v-for="(item, index) in version" :key="index" :value="item">{{
                  item
                }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="plugin_version" label="软件子版本">
              <Input
                v-model="data.plugin_version"
                placeholder="长度不超过50个字符"
                style="width: 300px"
              ></Input>
            </FormItem>
            <FormItem prop="note" label="任务备注">
              <Input
                v-model="data.note"
                placeholder="请输入备注"
                style="width: 300px"
                type="textarea"
                :rows="2"
              ></Input>
            </FormItem>
          </Col>
          <Col span="15">
            <Upload
              style="width: 300px"
              type="drag"
              :action="baseUrl + '/print/upload'"
              :multiple="false"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :default-file-list="upload.apk"
              :format="['apk']"
            >
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或拖拽上传</p>
              </div>
            </Upload>
          </Col>
        </Row>
      </Form>
      <div
        class="item_title"
        style="
          border-bottom: 1px solid #e8eaec;
          padding-bottom: 20px;
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
        "
      >
        <div>
          下发条件
          <Checkbox style="margin-left: 30px" v-model="isExcept">指定设备不更新</Checkbox>
        </div>
        <div style="margin: 0 30px">
          <span class="assign_machine" @click="addAssignMachine">指定设备</span>
          <Button v-preventReClick type="primary" @click="save" style="margin-left: 20px"
            >保存</Button
          >
          <Button @click="$router.back()" style="margin-left: 10px">取消</Button>
        </div>
      </div>

      <div>
        <Table :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="status">
            <span>{{
              row.software_version === row.software_version_after ? "成功" : "待更新"
            }}</span>
          </template>
        </Table>
        <!-- <div class="t-right" style="margin-top: 20px">
          <Page
            @on-change="pageChange"
            @on-page-size-change="sizeChange"
            :current="page.p + 1"
            :total="total"
            :page-size="10"
            show-elevator
            show-sizer
            show-total
          />
        </div> -->
      </div>
    </div>

    <Modal v-model="modal.visible" title="指定设备" :width="1200" footer-hide>
      <div>
        <div class="filter-box">
          <div>
            <span class="subtitle">设备序列号:</span>
            <Input
              v-model="search.sn"
              placeholder="请输入设备序列号"
              style="width: 160px; margin: 0 10px"
            />
            <span class="subtitle">设备站点:</span>
            <Select
              v-model="search.site_id"
              class="item"
              filterable
              style="width: 230px; margin: 0 10px"
              placeholder="请选择"
            >
              <Option v-for="(item, index) in siteList" :key="index" :value="item.id">{{
                item.name
              }}</Option>
            </Select>
            <span class="subtitle">合作伙伴:</span>
            <Select
              v-model="search.agent_id"
              class="item"
              filterable
              style="width: 230px; margin-left: 5px"
              placeholder="请选择"
            >
              <Option v-for="(item, index) in agentList" :key="index" :value="item.id">{{
                item.agent_name
              }}</Option>
            </Select>
            <span class="subtitle" style="margin-left: 10px">子版本号:</span>
            <Input
              v-model="search.plugin_version"
              placeholder="子版本号"
              style="width: 100px; margin: 0 10px"
            />
          </div>
          <div class="bottom">
            <span class="btn-filter" @click="getMachine()">筛选</span>
            <span class="btn" @click="reset">清空</span>
            <span
              class="btn-filter"
              style="margin-left: 10px"
              @click="selectAll(isMachineAll)"
              >{{ isMachineAll ? "取消全选" : "全选设备" }}</span
            >
          </div>
        </div>
        <Table
          :columns="machine_columns"
          :data="machine"
          ref="selection"
          @on-selection-change="selectTable"
        >
          <template slot-scope="{ row }" slot="status">
            <span>{{ status[row.status].name }}</span>
          </template>
        </Table>
        <div class="t-right" style="margin-top: 20px">
          <Page
            @on-change="mpageChange"
            @on-page-size-change="msizeChange"
            :current="search.p + 1"
            :total="machineTotal"
            :page-size="10"
            show-elevator
            show-sizer
            show-total
          />
        </div>
        <div style="margin: 20px 30px">
          <Button @click="modal.visible = false">取消</Button>
          <Button
            v-preventReClick
            type="primary"
            @click="saveAddMachine"
            style="margin-left: 10px"
            >确定</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config'
const disableBrand = ['佳能', '京瓷']

export default {
  data () {
    return {
      softwareName: [],
      software: [],
      version: [],
      data: {
        id: '',
        name: '',
        version: '',
        plugin_version: '',
        note: '',
        apk: '',
        sns: ''
      },
      rule: {
        name: [
          {
            required: true,
            message: '请选择软件名称',
            trigger: 'select'
          }
        ],
        version: [
          {
            required: true,
            message: '请选择软件主版本',
            trigger: 'select'
          }
        ],
        plugin_version: [
          {
            required: true,
            message: '请填写软件子版本',
            trigger: 'blur'
          }
        ]
      },
      upload: {
        apk: []
      },
      loading: false,
      baseUrl: '',
      list: [],
      columns: [
        { title: '序列号', key: 'sn', width: '150' },
        { title: '设备站点', key: 'site_name' },
        { title: '合作伙伴', key: 'agent_name' },
        { title: '当前软件', key: 'software_name', width: '150' },
        { title: '当前版本', key: 'software_version', width: '150' },
        { title: '更新后软件', key: 'software_name_after', width: '100' },
        { title: '更新后版本', key: 'software_version_after', width: '150' },
        { title: '更新状态', key: 'status', slot: 'status' },
        {
          title: '操作',
          key: 'operate',
          width: '200',
          render: (h, data) => {
            return h(
              'Button',
              {
                props: {
                  size: 'small',
                  type: 'error'
                },
                on: {
                  click: () => {
                    this.delete(data.row, data.index)
                  }
                }
              },
              '删除'
            )
          }
        }
      ],
      page: {
        p: 0,
        l: 1000
      },
      total: 0,
      modal: {
        visible: false,
        data: {
          sns: []
        }
      },
      agentList: [],
      siteList: [],
      search: {
        p: 0,
        l: 10,
        sn: '',
        site_id: '',
        agent_id: 0,
        plugin_version: ''
      },
      machineTotal: 0,
      machine: [], // 分页设备列表
      machineAllList: [], // 所有设备列表
      machineList: [], // 所有设备列表
      isMachineAll: false, // 是否全选设备列表
      isExcept: false,
      machine_columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '站点',
          width: 160,
          key: 'site_name'
        },
        {
          title: '序列号',
          width: 120,
          key: 'sn'
        },
        {
          title: '设备型号',
          minWidth: 110,
          key: 'machine_type_name',
          show: true
        },
        {
          title: '终端软件',
          minWidth: 130,
          key: 'software_name',
          show: true,
          render: (h, data) => {
            return h('span', {}, data.row.meter == 2 ? '-' : data.row.software_name)
          }
        },
        {
          title: '软件版本',
          minWidth: 100,
          key: 'software_version',
          show: true,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.software_version ? 'V' + data.row.software_version : ''
            )
          }
        },
        {
          title: '运营状态',
          minWidth: 90,
          key: 'status',
          show: true,
          render: (h, data) => {
            let status = {
              0: '正常',
              1: '禁用',
              2: '删除',
              3: '到期',
              4: '即将到期'
            }
            return h('span', {}, data.row.meter === 2 ? '-' : status[data.row.status])
          }
        },
        {
          title: '合作伙伴',
          minWidth: 160,
          key: 'agent_name',
          show: true
        },
        {
          title: '地址',
          minWidth: 230,
          key: 'address',
          show: true,
          tooltip: true,
          render: (h, data) => {
            return [h('span', {}, data.row.address + data.row.address_detail)]
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getAgentList',
      'SaveVersion',
      'GetVersionMachine',
      'GetSoftwareList',
      'GetMachineListData',
      'ImagesUpload',
      'getSite'
    ]),
    getData () {
      // 获取软件列表+对应主版本列表
      this.GetSoftwareList().then((res) => {
        this.softwareName = []
        this.software = res.data
        let selectName = this.data.name
        let versions = []
        res.data.map((item) => {
          this.softwareName.push(item.name)
          if (selectName && selectName === item.name) {
            versions = item.versions
          }
        })
        this.version = versions
      })
      /// /获取所有使用该版本的设备
      let id = this.data.id
      this.page.id = id
      let data = this.page
      this.GetVersionMachine(data).then((res) => {
        if (res.status) {
          this.list = res.data
          this.total = res.total
        }
      })
    },
    handleImageAdded (file, Editor, cursorLocation) {
      if (file.size > 800 * 1024) {
        this.$Message.warning({
          content: `图片过大(${file.name}),为避免用户加载时间过长,推荐裁剪后再编辑`,
          duration: 5
        })
        return false
      }
      var formData = new FormData()
      formData.append('file', file)
      this.ImagesUpload(formData).then((res) => {
        if (res.code === 1) { Editor.insertEmbed(cursorLocation, 'image', config.imgSrc + res.path) }
      })
    },
    uploadSuccess (response, file, fileList) {
      console.log('上传地址', response)
      this.data.apk = response
    },
    uploadError (e) {
      this.$Message.warning({
        content: `文件上传失败`,
        duration: 5
      })
    },
    save () {
      if (!this.data.apk) {
        this.$Message.warning({
          content: `请上传插件`,
          duration: 2
        })
        return
      }
      if (!this.data.sns) {
        this.$Message.warning({
          content: `请选择设备`,
          duration: 2
        })
        return
      }
      let isR = false
      this.list.every((item) => {
        if (item.software_version) {
          let arr = item.software_version.split('.')
          let ver = arr[arr.length - 1]
          if (parseInt(this.data.plugin_version) <= parseInt(ver)) {
            isR = true
            return false
          }
        }
      })
      if (isR) {
        this.$Message.warning({
          content: `软件子版本号必须大于所选设备的子版本号`,
          duration: 2
        })
        return
      }
      if (this.isExcept) {
        let sns = []
        this.machineAllList.map((item) => {
          let isExist = false
          this.list.map((it) => {
            if (item.sn === it.sn) {
              isExist = true
            }
          })
          if (!isExist) {
            sns.push(item.sn)
          }
        })
        this.data.sns = sns.join(',')
      }
      if (!this.data.sns) {
        this.data.sns = null
      }
      this.SaveVersion(this.data).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.$router.back()
        }
      })
    },

    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    staffChange () {
      this.getData()
    },
    msizeChange (l) {
      this.search.l = l
      this.getMachine(true)
    },
    mpageChange (p) {
      this.search.p = p - 1
      this.getMachine(true)
    },

    // 重置获取数据
    reset () {
      this.search = {
        p: 0,
        l: 10,
        sn: '',
        site_id: '',
        agent_id: '',
        software_name: this.data.name,
        software_version: this.data.version,
        plugin_version: ''
      }
      this.getMachine()
    },
    onSelectName (index) {
      this.version = []
      this.data.version = ''
      this.software.map((item) => {
        if (this.data.name == item.name) {
          this.version = item.versions
          console.log('软件版本', this.version)
        }
      })
    },
    versionCreate (val) {
      this.version.unshift(val)
    },
    addAssignMachine () {
      this.modal.visible = true
      this.search = {
        p: 0,
        l: 10,
        sn: '',
        site_id: '',
        agent_id: '',
        software_name: this.data.name,
        software_version: this.data.version,
        plugin_version: ''
      }
      this.isMachineAll = false
      this.GetMachineListData(this.search).then((res) => {
        this.machineList = res.data
        this.machineAllList = res.data
        this.machine = []
        this.machineTotal = res.total

        this.machineList.map((item, index) => {
          if (index < this.search.l) {
            this.machine.push(item)
          }
          if (disableBrand.includes(item.machine_brand_name)) {
            console.log('item.machine_brand_name', item.machine_brand_name)
            item._disabled = true
          }
          // 设置已选择的设备
          this.modal.data.sns.map((it) => {
            if (item.id === it.id && !item._disabled) {
              item._checked = true
            }
          })
        })
        console.log('所有设备', this.machineList.length)
      })
      this.getSite({ p: 0, l: 1000 }).then((res) => {
        this.siteList = res.data
      })
    },
    getMachine (isPage) {
      if (!isPage) {
        this.GetMachineListData(this.search).then((res) => {
          this.machineList = res.data
          this.machine = []
          this.machineTotal = res.total
          this.machineList.map((item, index) => {
            if (index < this.search.l) {
              this.machine.push(item)
            }
            if (disableBrand.includes(item.machine_brand_name)) {
              console.log('item.machine_brand_name', item.machine_brand_name)
              item._disabled = true
            }
            console.log('item===>', item)
            // 设置已选择的设备
            this.modal.data.sns.map((it) => {
              if (item.id === it.id && !item._disabled) {
                item._checked = true
              }
            })
          })
        })
      }
      this.machine = this.machineList.slice(
        this.search.p * this.search.l,
        (this.search.p + 1) * this.search.l
      )
      // 设置全选状态
      this.machine.map((item) => {
        item._checked = this.isMachineAll
        this.modal.data.sns.map((it) => {
          if (item.id === it.id) {
            item._checked = true
          }
        })
      })
    },
    delete (data, index) {
      this.list.splice(index, 1)
      let sns = this.data.sns.split(',')
      sns = sns.filter(function (item) {
        return item != data.sn
      })
      this.data.sns = sns.join(',')
      this.modal.data.sns.splice(index, 1)
    },
    selectTable (data) {
      let select = this.modal.data.sns
      console.log('data===>', data)
      let disableCount = 0
      data.map((item) => {
        console.log('item', item)
        if (disableBrand.includes(item.machine_brand_name)) {
          disableCount++
        }
      })
      if (disableCount) {
        this.$Message.warning(`当前有${disableCount}台已选择的设备不支持该功能`)
      }
      if (data.length > 0) {
        let json = select.concat(data)
        let newJson = []
        for (const item1 of json) {
          let flag = true // 建立标记，判断数据是否重复，true为不重复
          for (const item2 of newJson) {
            if (item1.id == item2.id) {
              flag = false
            }
          }
          if (flag) {
            // 判断是否重复
            newJson.push(item1)
          }
        }
        select = newJson
      } else {
        let temp = [...select].filter((x) =>
          [...this.machine].every((y) => y.id !== x.id)
        )
        select = temp
      }
      console.log('选择的', select)
      this.modal.data.sns = select
    },
    saveAddMachine () {
      this.modal.visible = false
      // let sns = this.data.sns ? this.data.sns.split(",") : [];
      let snArray = [],
        selectList = []
      this.modal.data.sns.map((item) => {
        selectList.push({
          sn: item.sn,
          site_name: item.site_name,
          agent_name: item.agent_name,
          software_name: item.software_name,
          software_version: item.software_version,
          software_name_after: this.data.name,
          software_version_after: this.data.version + '.' + this.data.plugin_version,
          status: '待更新'
        })
      })
      let newlist = this.list.concat(selectList)
      let newJson = []
      newlist.map((item) => {
        let flag = true
        newJson.map((item2) => {
          if (item.sn == item2.sn) {
            flag = false
          }
        })
        if (flag) {
          snArray.push(item.sn)
          newJson.push(item)
        }
      })
      this.list = newJson
      this.total = snArray.length
      this.data.sns = snArray.join(',')
    },
    selectAll (isAll) {
      this.isMachineAll = !isAll
      this.$refs.selection.selectAll(this.isMachineAll)
      this.modal.data.sns = this.isMachineAll ? this.machineList : []
    }
  },
  mounted () {
    let params = this.$route.params.data
    if (params) {
      this.data = JSON.parse(params)
      this.upload.apk.push({ name: 'release.apk', url: this.data.apk })
    }
    this.getData()
    this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.agentList = res.data
    })
  },
  created () {
    this.baseUrl =
      process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
